// extracted by mini-css-extract-plugin
export default {"container":"header_container__AzWgZ","content":"header_content__HKG-r","balance":"header_balance__dtPio","balance_number":"header_balance_number__r2ZcX"};